// extracted by mini-css-extract-plugin
var _1 = "LayoutHeaderMenuToggle-moduleLayoutHeaderMenuToggle__plT5D";
var _2 = "LayoutHeaderMenuToggle-modulecollapsed__DBT9b";
export { _1 as "LayoutHeaderMenuToggle", _2 as "collapsed" }
